<template>
    <div>
        <slot name="activator" :toggle="() => showModal = !showModal" />

        <b-modal
            id="dropDisabilitiesModal"
            v-model="showModal"
            :title="$t('Mark as dropped')"
            scrollable
            size="lg"
            @show="fetchData(params)"
            @close="form.reset()"
        >
            <template #modal-footer>
                <b-button :disabled="form.busy" type="submit" variant="primary" @click="handleSubmit">
                    {{ $t('Save') }}

                    <b-spinner v-if="form.busy" small />
                    <fa v-else class="ml-1" icon="save" />
                </b-button>
            </template>

            <b-form @submit.prevent="handleSubmit">
                <b-form-group
                    :invalid-feedback="form.errors.get('date')"
                    :label="$t('Date')"
                    :label-for="uuid + '_date'"
                    :state="form.errors.has('date') ? false : null"
                >
                    <b-form-datepicker
                        :id="uuid + '_date'"
                        v-model="form.date"
                        :locale="$i18n.locale"
                        :min="$moment().add(1, 'day').toDate()"
                        :state="form.errors.has('date') ? false : null"
                        class="mb-2"
                        required
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="form.errors.get('notice')"
                    :label="$t('Notice')"
                    :state="form.errors.has('notice') ? false : null"
                    label-for="notice"
                >
                    <b-form-textarea
                        id="notice"
                        v-model="form.notice"
                        :state="form.errors.has('notice') ? false : null"
                        name="notice"
                    />
                </b-form-group>


                <loading-bar
                    v-if="pending"
                    :absolute="false"
                />
                <tree-view
                    v-else-if="items.length"
                    v-model="form.room_disabilities"
                    :errors="form.errors"
                    :items="items"
                    class="mt-3"
                    error-prefix="rooms"
                />
                <no-results-found v-else />
            </b-form>
        </b-modal>
    </div>
</template>
<script>
    import fetchData from "@/mixins/fetchData";
    import Form from "vform";
    import TreeView from "@/components/TreeView";

    export default {
        name: 'DropDisabilities',
        components: {TreeView},
        mixins: [fetchData],
        props: {
            projectId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                lazy: true,
                form: new Form({
                    date: this.$moment().format('YYYY-MM-DD'),
                    notice: null,
                    room_disabilities: []
                }),
                showModal: false,
            }
        },
        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/disabilities?status=open`
            }
        },
        methods: {

            async handleSubmit() {
                if (this.form.busy) return;

                try {
                    await this.form.post('/api/drop_rooms_disabilities');
                    this.$root.$emit('disabilities-dropped')

                    this.showModal = false;
                } catch (e) { e.response || throw e; }
            },
        }

    }
</script>
